module.exports = __webpack_public_path__ + "img/arrow_blue.c42acf41.svg";